import { emptySplitApiAccountService as api } from "./empty.account-service.api";
import {
  GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg,
  GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse,
  GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiArg,
  GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiResponse,
  GetUsersMeOrganisationsCurrentResourceExplorerPossibleGroupingsApiResponse,
  GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg,
  GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse,
  GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiArg,
  GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiResponse,
  GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiArg,
  GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiResponse,
  GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiArg,
  GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiResponse,
  GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiArg,
  GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiResponse,
  GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiArg,
  GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiResponse,
  GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiArg,
  GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiResponse,
  GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiArg,
  GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiResponse,
  PostUsersMeOrganisationsCurrentResourceExplorerApiArg,
  PostUsersMeOrganisationsCurrentResourceExplorerApiResponse,
  ResourceExplorerFilterSchema,
} from "./cloudchipr.api";

// This file is written by hand, not autogenerated
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    //common
    getResourceExplorerPossibleGroupingsFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentResourceExplorerPossibleGroupingsApiResponse,
      GetResourceExplorerPossibleGroupingsArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/resource-explorer/possible-groupings`,
      }),
    }),
    getOrganisationQuarterStartMonthByIdFromAccountService: build.query<
      GetOrganisationQuarterStartMonthByIdFromAccountServiceApiResponse,
      GetOrganisationQuarterStartMonthByIdFromAccountServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/quarter-start-month`,
      }),
    }),

    //Dashboard endpoints
    getDashboardsByDashboardIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiResponse,
      GetUsersMeOrganisationsCurrentDashboardsByDashboardIdAccountServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/dashboards/${queryArg.dashboardId}`,
      }),
    }),
    getWidgetsCostAndUsageSummaryByWidgetIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiResponse,
      GetWidgetsCostAndUsageSummaryByWidgetIdFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/widgets/cost-and-usage-summary/${queryArg.widgetId}`,
      }),
    }),
    getWidgetsCostBreakdownByWidgetIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiResponse,
      GetWidgetsCostBreakdownByWidgetIdFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/widgets/cost-breakdown/${queryArg.widgetId}`,
      }),
    }),
    getWidgetsLargestCostChangesByWidgetIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiResponse,
      GetWidgetsLargestCostChangesByWidgetIdFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/widgets/largest-cost-changes/${queryArg.widgetId}`,
      }),
    }),
    getWidgetsCommitmentsUtilizationByWidgetIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiResponse,
      GetWidgetsCommitmentsUtilizationByWidgetIdFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/widgets/commitments-utilization/${queryArg.widgetId}`,
      }),
    }),
    getWidgetsCoverageByWidgetIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiResponse,
      GetWidgetsCoverageByWidgetIdFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/widgets/coverage/${queryArg.widgetId}`,
      }),
    }),
    getWidgetsTextByWidgetIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiResponse,
      GetWidgetsTextByWidgetIdFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/widgets/text/${queryArg.widgetId}`,
      }),
    }),
    getWidgetsNormalizedCostWidgetIdFromAccountService: build.query<
      GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiResponse,
      GetWidgetsNormalizedCostByWidgetIdFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/widgets/normalized-cost/${queryArg.widgetId}`,
      }),
    }),

    //Billing Explorer endpoints
    getResourceExplorerViewsByResourceExplorerViewIdFromAccountService:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiResponse,
        GetResourceExplorerViewsByResourceExplorerViewIdFromAccountServiceApiArgs
      >({
        query: (queryArg) => ({
          url: `/organisations/${queryArg.organisationId}/resource-explorer/views/${queryArg.resourceExplorerViewId}`,
        }),
      }),
    getResourceExplorerFiltersByFilterProviderAndFilterTypeValuesFromAccountService:
      build.query<
        GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiResponse,
        GetResourceExplorerFiltersByFilterProviderAndFilterTypeValuesFromAccountServiceApiArgs
      >({
        query: (queryArg) => ({
          url: `/organisations/${queryArg.organisationId}/resource-explorer/filters/${queryArg.filterProvider}/${queryArg.filterType}/values`,
          params: { key: queryArg.key },
        }),
      }),
    postResourceExplorerDataFromAccountService: build.mutation<
      PostUsersMeOrganisationsCurrentResourceExplorerApiResponse,
      PostResourceExplorerDataFromAccountServiceApiArgs
    >({
      query: (queryArg) => ({
        url: `/organisations/${queryArg.organisationId}/resource-explorer `,
        method: "POST",
        body: queryArg.resourceExplorerFilterSchema,
        headers: { "Content-Type": queryArg["Content-Type"] },
      }),
    }),
  }),
  overrideExisting: false,
});

export { injectedRtkApi as cloudChiprApiAccountService };

export type GetOrganisationQuarterStartMonthByIdFromAccountServiceApiArg = {
  organisationId: string;
};
export type GetOrganisationQuarterStartMonthByIdFromAccountServiceApiResponse =
  | number
  | undefined;

export interface GetUsersMeOrganisationsCurrentDashboardsByDashboardIdAccountServiceApiArg
  extends GetUsersMeOrganisationsCurrentDashboardsByDashboardIdApiArg {
  organisationId: string;
}

export interface GetWidgetsCostAndUsageSummaryByWidgetIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentWidgetsCostAndUsageSummaryByWidgetIdApiArg {
  organisationId: string;
}

export interface GetWidgetsCostBreakdownByWidgetIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetIdApiArg {
  organisationId: string;
}

export interface GetWidgetsLargestCostChangesByWidgetIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentWidgetsLargestCostChangesByWidgetIdApiArg {
  organisationId: string;
}

export interface GetWidgetsCommitmentsUtilizationByWidgetIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiArg {
  organisationId: string;
}

export interface GetWidgetsCoverageByWidgetIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentWidgetsCoverageByWidgetIdApiArg {
  organisationId: string;
}

export interface GetWidgetsTextByWidgetIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentWidgetsTextByWidgetIdApiArg {
  organisationId: string;
}

export interface GetWidgetsNormalizedCostByWidgetIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentWidgetsNormalizedCostByWidgetIdApiArg {
  organisationId: string;
}

export interface GetResourceExplorerViewsByResourceExplorerViewIdFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewIdApiArg {
  organisationId: string;
}

export interface GetResourceExplorerFiltersByFilterProviderAndFilterTypeValuesFromAccountServiceApiArgs
  extends GetUsersMeOrganisationsCurrentResourceExplorerFiltersByFilterProviderAndFilterTypeValuesApiArg {
  organisationId: string;
}

export interface PostResourceExplorerDataFromAccountServiceApiArgs
  extends Omit<
    PostUsersMeOrganisationsCurrentResourceExplorerApiArg,
    "resourceExplorerFilterSchema"
  > {
  organisationId: string;
  resourceExplorerFilterSchema: ResourceExplorerFilterSchemaForAccountService;
}

export interface GetResourceExplorerPossibleGroupingsArgs {
  organisationId: string;
}

export type ResourceExplorerFilterSchemaForAccountService =
  ResourceExplorerFilterSchema & {
    start_month_of_quarter?: number;
  };

export const {
  //Dashboard
  useGetDashboardsByDashboardIdFromAccountServiceQuery,
  useGetWidgetsCommitmentsUtilizationByWidgetIdFromAccountServiceQuery,
  useGetWidgetsCoverageByWidgetIdFromAccountServiceQuery,
  useGetWidgetsCostBreakdownByWidgetIdFromAccountServiceQuery,
  useGetWidgetsCostAndUsageSummaryByWidgetIdFromAccountServiceQuery,
  useGetWidgetsLargestCostChangesByWidgetIdFromAccountServiceQuery,
  useGetWidgetsTextByWidgetIdFromAccountServiceQuery,
  useGetWidgetsNormalizedCostWidgetIdFromAccountServiceQuery,

  //Billing Explorer
  useGetResourceExplorerViewsByResourceExplorerViewIdFromAccountServiceQuery,
  useGetResourceExplorerFiltersByFilterProviderAndFilterTypeValuesFromAccountServiceQuery,
  usePostResourceExplorerDataFromAccountServiceMutation,

  //common
  useGetResourceExplorerPossibleGroupingsFromAccountServiceQuery,
  useGetOrganisationQuarterStartMonthByIdFromAccountServiceQuery,
} = injectedRtkApi;
